#import "./related-lead-fragment.graphql"

fragment ChatFragment on Chat {
    id
    name
    htmlUrlPath
    chatItems {
        timestamp
        body
        chatter
        type
    }
    activityType {
        id
        name
    }
    logNote {
        id
        bodyHtml
    }
    participants {
        id
        name
        avatarUrl
        initials
        htmlUrl
    }
    relatedLeads {
        id
        name
        ... on Lead {
            ...RelatedLeadFragment
        }
    }
}
